<template>
  <div>
    <SchemaTablePage
      ref="tablePageRef"
      layout-mode="page"
      :search-schema="searchSchema"
      :columns="tableColumns"
      :default-query="defaultQuery"
      :request="request"
      :build-params="buildParams"
      :parse-result="parseResult"
      :table-listeners="tableListeners"
    >
      <template #table-header>
        <div class="actions">
          <el-button type="primary" size="mini" @click="handleBlackIp">批量拉黑IP</el-button>
          <el-button type="primary" size="mini" @click="handleBlackDevice">批量拉黑设备</el-button>
        </div>
      </template>

      <template #colMemberAccount="{ row }">
        <MemberAccountCell :row="row" :username="row.username" :uid="row.uid" :vip-level="row.vip_level" />
      </template>
      <template #colDeviceId="{ row }">
        <el-link type="primary" @click="handleDeviceDetail(row)">{{ row.login_device_id }}</el-link>
      </template>
      <template #colLoginIp="{ row }">
        <el-button type="text" size="small" @click="handleIpDetail(row, 'login')">{{ row.login_ip }}</el-button>
      </template>
      <template #colRegisterIp="{ row }">
        <el-button type="text" size="small" @click="handleIpDetail(row, 'register')">{{ row.register_ip }}</el-button>
      </template>
      <template #colLoginTime="{ row }">{{ parseTime(row.login_time) }}</template>
      <template #colLoginType="{ row }">
        <el-tag v-if="getLoginTypeText(row.login_type)" size="small" :type="getLoginTypeTagType(row.login_type)">
          {{ getLoginTypeText(row.login_type) }}
        </el-tag>
        <span v-else>-</span>
      </template>
    </SchemaTablePage>

    <!-- 设备详情弹窗 -->
    <ManageDeviceDetailDialog
      :visible.sync="deviceDetailVisible"
      :device-no="currentDeviceNo"
      :ip="clickRow?.login_ip"
    />

    <!-- IP详情弹窗 -->
    <ManageIpDetailDialog :visible.sync="ipDetailVisible" :ip="currentIp" :device-no="clickRow?.login_device_id" />

    <!-- 拉黑IP弹窗 -->
    <ManageBlackIpDialog :visible.sync="blackIpVisible" :selected-rows="selectedRows" @success="handleBlackSuccess" />

    <!-- 拉黑设备弹窗 -->
    <ManageBlackDeviceDialog
      :visible.sync="blackDeviceVisible"
      :selected-rows="selectedRows"
      @success="handleBlackSuccess"
    />
  </div>
</template>

<script>
import { getLoginLogList, getLoginLog } from '@/api/riskControl/loginLog.js'
import SchemaTablePage from '@/components/SchemaTablePage'
import { parseTime } from '@/utils'
import ManageBlackDeviceDialog from './components/ManageBlackDeviceDialog.vue'
import ManageBlackIpDialog from './components/ManageBlackIpDialog.vue'
import ManageDeviceDetailDialog from './components/ManageDeviceDetailDialog.vue'
import ManageIpDetailDialog from './components/ManageIpDetailDialog.vue'
import MemberAccountCell from '@/components/MemberAccountCell.vue'
export default {
  name: 'LoginLogManage',
  components: {
    SchemaTablePage,
    ManageDeviceDetailDialog,
    ManageIpDetailDialog,
    ManageBlackIpDialog,
    ManageBlackDeviceDialog,
    MemberAccountCell,
  },
  data() {
    return {
      clickRow: null,
      defaultQuery: {
        username: '',
        inviter_obj: { inputVal: '', prepend: 'inviter_username' },
        login_device_type: '',
        ip_obj: { inputVal: '', prepend: 'login_ip' },
        login_country: '',
        login_type: '',
        loginTime: [],
      },
      searchSchema: [
        { prop: 'username', label: '会员账号', component: 'input', componentProps: { clearable: true } },
        {
          prop: 'inviter_obj',
          label: '上级代理',
          component: 'prepend-input',
          options: [
            { label: '账号', value: 'inviter_username' },
            { label: 'ID', value: 'inviter_uid' },
          ],
          componentProps: { clearable: true, prependWidth: '85px' },
        },
        { prop: 'login_device_type', label: '登录设备', component: 'input', componentProps: { clearable: true } },
        {
          prop: 'ip_obj',
          label: 'IP',
          component: 'prepend-input',
          options: [
            { label: '登录IP', value: 'login_ip' },
            { label: '注册IP', value: 'register_ip' },
          ],
          componentProps: { clearable: true, prependWidth: '85px' },
        },
        {
          prop: 'login_type',
          label: '登录类型',
          component: 'select',
          componentProps: { clearable: true },
          options: [
            { label: '全部', value: '' },
            { label: '正常登录', value: '1' },
            { label: '黑IP登录', value: '2' },
            { label: '黑设备ID登录', value: '3' },
          ],
        },
        {
          prop: 'loginTime',
          label: '登录时间',
          component: 'datetime-range',
          componentProps: { defaultTime: ['00:00:00', '23:59:59'] },
          span: { xs: 24, sm: 12, md: 12, lg: 8, xl: 8, xxl: 8 },
        },
        { component: 'actions' },
      ],
      tableColumns: [
        { fixed: 'left', type: 'selection', width: 40, align: 'center', resizable: false },
        { prop: 'username', label: '会员账号', width: 140, resizable: false, slot: 'colMemberAccount' },
        { prop: 'login_device', label: '登录设备', width: 80, resizable: false },
        { prop: 'login_host', label: '登录域名', minWidth: 180, resizable: false },
        { prop: 'login_device_id', label: '设备号', minWidth: 200, resizable: false, slot: 'colDeviceId' },
        { prop: 'login_ip', label: '登录IP', width: 110, resizable: false, slot: 'colLoginIp' },
        { prop: 'register_ip', label: '注册IP', width: 110, resizable: false, slot: 'colRegisterIp' },
        { prop: 'login_country', label: '登录地址', minWidth: 150, resizable: false },
        { prop: 'login_time', label: '登录时间', width: 140, resizable: false, slot: 'colLoginTime' },
        { prop: 'login_type', label: '登录类型', width: 100, resizable: false, slot: 'colLoginType' },
      ],
      // 选中的行
      selectedRows: [],
      // 设备详情弹窗
      deviceDetailVisible: false,
      currentDeviceNo: '',
      // IP详情弹窗
      ipDetailVisible: false,
      currentIp: '',
      // 拉黑IP弹窗
      blackIpVisible: false,
      // 拉黑设备弹窗
      blackDeviceVisible: false,
    }
  },
  computed: {
    tableListeners() {
      return {
        'selection-change': this.handleSelectionChange,
      }
    },
  },
  created() {
    const { member_username } = this.$route.query
    if (member_username) {
      this.defaultQuery.username = member_username
    }
  },
  // beforeRouteLeave(to, from, next) {
  //   const hasQuery = from.query && from.query.member_username
  //   if (hasQuery && to.path !== from.path) {
  //     next(false)
  //     const cleanQuery = {}
  //     this.$router.replace({ path: from.path, query: cleanQuery }).then(() => {
  //       this.$router.push(to.fullPath)
  //     })
  //   } else {
  //     next()
  //   }
  // },
  methods: {
    // 时间格式化函数
    parseTime,

    request(params) {
      // return getLoginLogList(params)
      return getLoginLog(params)
    },
    buildParams({ query, page, limit }) {
      const params = {
        page,
        page_size: limit,
      }

      const q = query || {}
      if (q.username) params.username = q.username
      if (q.inviter_obj && typeof q.inviter_obj === 'object') {
        const { prepend, inputVal } = q.inviter_obj
        const v = inputVal != null ? String(inputVal).trim() : ''
        if (prepend === 'inviter_username' && v) params.inviter_username = v
        if (prepend === 'inviter_uid' && v) params.inviter_uid = Number(v)
      } else {
        if (q.inviter_username) params.inviter_username = q.inviter_username
        if (q.inviter_uid) params.inviter_uid = Number(q.inviter_uid)
      }
      if (q.login_device_type) params.login_device_type = q.login_device_type
      if (q.ip_obj && typeof q.ip_obj === 'object') {
        const { prepend, inputVal } = q.ip_obj
        const v = inputVal != null ? String(inputVal).trim() : ''
        if (prepend === 'login_ip' && v) params.login_ip = v
        if (prepend === 'register_ip' && v) params.register_ip = v
      } else {
        if (q.login_ip) params.login_ip = q.login_ip
        if (q.register_ip) params.register_ip = q.register_ip
      }
      if (q.login_country) params.login_country = q.login_country
      if (q.login_type) params.login_type = Number(q.login_type)

      if (q.loginTime && q.loginTime.length === 2) {
        params.start_time = Math.floor(new Date(q.loginTime[0]).getTime())
        params.end_time = Math.floor(new Date(q.loginTime[1]).getTime())
      }

      return params
    },
    parseResult(response) {
      return {
        list: response?.data?.list || [],
        total: response?.data?.total || 0,
      }
    },
    handleRefresh() {
      this.$refs.tablePageRef?.reload?.()
    },

    // 选择变化
    handleSelectionChange(selection) {
      this.selectedRows = selection
    },

    // 设备详情
    handleDeviceDetail(row) {
      this.clickRow = row
      this.currentDeviceNo = row.login_device_id
      this.deviceDetailVisible = true
    },

    // IP详情
    handleIpDetail(row, ipType) {
      this.clickRow = row
      this.currentIp = ipType === 'login' ? row.login_ip : row.register_ip
      this.ipDetailVisible = true
    },

    // 拉黑IP
    handleBlackIp() {
      if (this.selectedRows.length === 0) {
        this.$message.info('请先选择要操作的记录')
        return
      }
      this.blackIpVisible = true
    },

    // 拉黑设备
    handleBlackDevice() {
      if (this.selectedRows.length === 0) {
        this.$message.info('请先选择要操作的记录')
        return
      }
      this.blackDeviceVisible = true
    },

    // 拉黑成功
    handleBlackSuccess() {
      this.$message.success('操作成功')
      this.$refs.tablePageRef?.reload?.()
    },

    // 获取登录类型文本
    getLoginTypeText(loginType) {
      if (!loginType || loginType === 0) return ''
      const typeMap = {
        1: '正常登录',
        2: '黑ip登录',
        3: '黑设备ID登录',
      }
      return typeMap[loginType] || ''
    },

    // 获取登录类型标签类型
    getLoginTypeTagType(loginType) {
      if (!loginType || loginType === 0) return ''
      const typeMap = {
        1: 'success',
        2: 'danger',
        3: 'warning',
      }
      return typeMap[loginType] || 'info'
    },
  },
}
</script>

<style scoped>
/* 页面样式 */
.page-search {
  color: red;
}

.page-content :deep(.el-table-column--selection .cell) {
  padding-left: 10px;
  padding-right: 10px;
}
</style>
